module.exports = __webpack_public_path__ + "assets/dummy_banner.png";